export default {
    name: "ImageSpotFiftyFifty",
    setup(){
        
    }
}